import "./ui/styles.css";
import { Game } from "./Game";
import { installSafeAreaVars } from "./utils/safeArea";

installSafeAreaVars();

const app = document.getElementById("app");
if (!app) throw new Error("#app not found");

// Hide the boot splash once we've reached this point.
const boot = document.getElementById("boot");
if (boot) boot.classList.add("hidden");

new Game(app);

// PWA service worker — vite-plugin-pwa virtual module.
// We import dynamically so a failure here can't crash the game.
import("virtual:pwa-register")
  .then(({ registerSW }) => {
    registerSW({ immediate: true });
  })
  .catch(() => {
    // No SW in dev or unsupported — fine.
  });

// Any uncaught error: don't whiteout the game; log and continue.
window.addEventListener("error", (e) => {
  console.error("[suedegod] uncaught:", e.error || e.message);
});
window.addEventListener("unhandledrejection", (e) => {
  console.error("[suedegod] unhandled rejection:", e.reason);
});
